import {Injectable} from '@angular/core';
import {RequestOptions, Headers} from '@angular/http';
import {HttpClient} from '@angular/common/http';
import {CreateUser} from './Account/CreateUser';
import {CardStyle} from './CardDesigner/CardSave';
import {Subject} from 'rxjs';
import {FontList} from './FontList';
import {CardImage} from "./CardCreator/CardImage";
import {CreatingCard} from "./CardCreator/CreatingCard";
import {CardHole} from "./CardCreator/CardBacks";
import {CardCreatorStyle} from "./CardCreator/CardCreateSave";

@Injectable()
export class AppService {
  admin = false;
  sponsor = false;
  isMobile = false;
  isAndroid = false;
  isIOS = false;
  appMode = 4; // 0 = CardCreator, 1 = Playing Game, 2 = SponsorConsole, 3 = AdminConsole, 4 = HomePage
  game = -1; //-1 = PT, 2 = DoF
  custom = -1; // -1 = Undefined, 0 = Sponsor, 1 = Custom,
  theme = 0; // 0 = Basic, 1 = Space, 2 = Doodle, 3 = CardTable
  currency = -1;
  loggedIn = false;
  user = null;
  defer = null;
  userCards = [];
  hasImageForID = [];
  selectedSavedCard = null;
  selectedCardBack = null;
  hasRunBlankRefresh = false;
  cardAdChanged = false;
  errorText = "";
  selectedStates = [];
  selectedCities = [];
  filterLocations = true;
  impressionCount = 10;
  broadcaster: Subject<Object> = new Subject<Object>();
  url = "https://arcane-inlet-43300.herokuapp.com";
  // url = "http://10.10.10.179:8000";
  images: any = [];
  hasImageAdded = false;

  backgroundColor = "#ffffff";
  imageChanged: boolean = false;
  selectedImage: CardImage = null;
  selectedHole: CardHole = null;
  fonts: FontList = null;
  fontList = [];
  designerSub = null;
  clickPixelForColor = false;
  isUnityEditing: boolean = false;
  viewMode = 0;
  showAllButtons: boolean = false;
  showIntro: boolean = true;
  showReady = false;

  inCropMode = false;
  cropShape: number = 0; //0 = square, 1 = circle
  creating: CreatingCard = null;
  generatedCardBack = '';

  constructor(private http: HttpClient) {

  }

  resetVariables() {
    this.admin = false;
    this.sponsor = false;
    this.appMode = 0;
    this.loggedIn = false;
    this.user = null;
    this.defer = null;
    this.userCards = [];
    this.hasImageForID = [];
    this.selectedSavedCard = null;
    this.cardAdChanged = false;
    this.errorText = "";
    this.selectedStates = [];
    this.selectedCities = [];
    this.filterLocations = true;
    this.impressionCount = 10;
  }

  broadcast(value: Object) {
    this.broadcaster.next(value);
  }

  getHeader() {
    let headers = new Headers({
      'Accept': 'application/json; charset=utf-8',
      'content-type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'credentials': 'include'
    });
    let options: any ={
      headers: headers,
      withCredentials: true
    };
    return options;
  }

  setUserID(userID) {
    localStorage.setItem("userID", userID);
  }

  getUserID() {
    return localStorage.getItem("userID");
  }

  clearUserID() {
    localStorage.removeItem("userID");
  }

  setSession(session) {
    localStorage.removeItem("session");
    localStorage.setItem("session", session);
  }

  getSessionID() {
    return localStorage.getItem("session");
  }

  getCookie(name) {
    let value = document.cookie;
    let parts = value.split("; ");
    for (let i = 0; i < parts.length; i++) {
      let keyValue = parts[i].split("=");
      if (keyValue[0] === name) {
        return keyValue[1];
      }
    }
    return null;
  }

  makeNewCardBack(style : CardCreatorStyle) {
    return this.uploadCardBack(0, style);
  }

  updateCardBack(id, style : CardCreatorStyle) {
    return this.uploadCardBack(id, style);
  }

  fireWebViewEvent(type: number, cardID: number, count: number, price: number) {
    var win = window.open("uniwebview://action?type=" + type + "&cardID=" + cardID + "&count=" + count + "&price=" + price + "", '_blank');
    win.focus();
  }

  fireColorChangeEvent() {
    // var win = window.open("uniwebview://action?type=" + 3 + "", '_blank');
    // win.focus();
  }

  forgotPassword(email) { //412 if user not found, sends 403 if found but not verified, 400 otherwise
    return this.http.post(this.url + "/user/password/reset/", {email: email}, this.getHeader());
  }

  uploadCardBack(id, style : CardCreatorStyle) {
    return this.http.post(this.url + "/style/" + id + "/save/", style, this.getHeader());
  }

  getUploadedImage(id) {
    return this.http.get(this.url + "/style/" + id + "/bytes/", this.getHeader());
  }

  createAccount(user: CreateUser) {
    return this.http.post(this.url + "/user/create/", user, this.getHeader());
  }

  getAccount(userID) {
    return this.http.get(this.url + "/user/" + userID + "/", this.getHeader());
  }

  logIntoAccount(email, pass) {
    return this.http.post(this.url + "/login/", {email: email, password: pass}, this.getHeader());
  }

  sessionLogin(id, session) {
    return this.http.post(this.url + "/user/" + id + "/login/", {session: session}, this.getHeader());
  }

  makeCardCustom(id, uses) {
    return this.http.post(this.url + "/style/" + id + "/custom/", {session: this.getSessionID(), custom_uses: uses}, this.getHeader());
  }

  makeCardSponsor(id, ad, paid, approv) {
    return this.http.post(this.url + "/style/" + id + "/edit/", {session: this.getSessionID(), advertisement: ad, paid_for: paid, approved: approv}, this.getHeader());
  }

  deleteCard(id) {
    return this.http.post(this.url + "/style/" + id + "/delete/", {session: this.getSessionID()}, this.getHeader());
  }

  getCardUseHistory(styleID, start, end) {
    return this.http.get(this.url + "/style/" + styleID + "/history?session=" + this.getSessionID() + "&start=" + start + "&end=" + end);
  }

  getCardTransactionHistory(styleID) {
    return this.http.get(this.url + "/user/" + this.getUserID() + "/transaction?session=" + this.getSessionID() + "&style=" + styleID, this.getHeader());
  }

  updateCardLocation(id, session, locations) {
    return this.http.post(this.url + "/style/" + id + "/advertise/",
      {
        session: this.getSessionID(),
        locations: locations
      },
      this.getHeader());
  }

  getAdminConsoleCards() {
    return this.http.get(this.url + "/style/unapproved", this.getHeader());
  }

  processCard(cardID, user, result, message) {
    return this.http.post(this.url + "/style/" + cardID + "/process/",
      {
        user: user,
        session: this.getSessionID(),
        approved: result,
        message: message
      },
      this.getHeader());
  }

  searchCards(user, pApp, app, appBy, ad, paid, rej, strict, imp, email) {
    return this.http.post(this.url + "/style/search/",
      {
        user: user,
        session: this.getSessionID(),
        preliminary_approved: pApp,
        approved: app,
        approved_by: appBy,
        advertisement: ad,
        paid: paid,
        rejected: rej,
        strict_false: strict,
        impressions: imp,
        email: email
      },
      this.getHeader());
  }

  logOut() {
    this.setUserID(null);
    this.resetVariables();
    window.location.href = "";
  }

  getUserCards(userID) {
    return this.http.get(this.url + "/style/" + userID + "/all/detailed/", this.getHeader());
  }

  mapSearch(search) {
    return this.http.post(this.url + "/map/search/", {search: search}, this.getHeader());
  }

  resendVerificationCode() {
    return this.http.post(this.url + "/user/" + this.user.id + "/resend/", {}, this.getHeader());
  }

  verifyAccount(code) {
    return this.http.post(this.url + "/user/" + this.user.id + "/verify/", {code: code}, this.getHeader());
  }
  verifyAccountByID(user, code) {
    return this.http.post(this.url + "/user/" + user + "/verify/", {code: code}, this.getHeader());
  }

  updateEmail(email) {
    return this.http.post(this.url + "/user/" + this.user.id + "/updateEmail/", {session: this.getSessionID(), email: email}, this.getHeader());
  }

  updatePassword(password, old) {
    return this.http.post(this.url + "/user/" + this.user.id + "/password/", {session: this.getSessionID(), password: password, old_password: old}, this.getHeader());
  }

  changeAccountTier(updateUserID, toTier) {
    return this.http.post(this.url + "/user/tier/", {session: this.getSessionID(), admin: this.user.id, user: updateUserID, tier: toTier}, this.getHeader());
  }

  getUserList() {
    return this.http.post(this.url + "/user/accounts/", {session: this.getSessionID(), admin: this.user.id}, this.getHeader());
  }

  getAllCardsForUser() {
    console.log("Window HREF: ", window.location.href);
    if (this.user.tier === 100 || this.user.tier === 99) {
      // if (window.location.href.indexOf("http://10.10.") !== -1) {
        this.admin = true;
        this.appMode = 3;
      // }
    }
    this.getUserCards(this.user.id).subscribe((data: any) => {
      console.log("Got user cards: ", data.styles);
      this.userCards = data.styles;
      this.sponsor = this.userCards.some(c => c.advertisement);
      if (this.appMode !== 3) {
        this.appMode = 4; //Jump to homepage
        // this.appMode = 2; //Jump to sponsor console
      }
      if (this.appMode === 2) {
        this.broadcast({event: 'loadSponsorConsole'});
      }
      for (let key in localStorage) {
        let found = false;
        if (key.indexOf("customCardID") !== -1) {
          found = this.userCards.some((i) => {
            return ("customCardID" + i.id) === key;
          });
          if (!found) {
            localStorage.removeItem(key);
          } else {
            let id = parseInt(key.replace("customCardID", ""));
            this.hasImageForID[id] = true;
          }
        }
      }
    }, (error) => {
      console.log("Error getting user cards: ", error);
    });
  }

  createClone(obj) {
    let copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" !== typeof obj) {
      return obj;
    }

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.createClone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (let attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          copy[attr] = this.createClone(obj[attr]);
        }
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
}
